import ToDownload2 from './ToDownload2'
import type { ToDownload2Props } from './ToDownload2'

export default ToDownload2
export type { ToDownload2Props }
